import React, { FC } from 'react'

import { EuiButton, EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiLink, EuiLoadingSpinner, EuiPopover, EuiPopoverFooter, EuiPopoverTitle, EuiSelectable, EuiSelectableOption, EuiText } from '@elastic/eui'
import { PopoverAnchorPosition } from '@elastic/eui/src/components/popover/popover'

export interface IAcSearchSelectorPopover {
  isLoading?: boolean
  options: EuiSelectableOption[]
  currentValue?: string
  onRefreshClick?: () => void
  onNewClick?: () => void
  linkText?: string
  popoverAnchorPosition?: PopoverAnchorPosition
  footerButtonText?: string
}

export const AcSearchSelectorPopover: FC<IAcSearchSelectorPopover> = props => {
  const [showPopover, setShowPopover] = React.useState<boolean>(false)

  const onNewButtonClick = () => {
    setShowPopover(false)
    props.onNewClick?.()
  }

  return (
    <EuiPopover
      panelStyle={{ minWidth: '21rem' }}
      button={
        <EuiText size='xs' color='ghost'>
          <EuiLink style={{ color: '#f49342' }} onClick={() => setShowPopover(true)}>
            {props.linkText ?? props.currentValue}
          </EuiLink>
        </EuiText>
      }
      isOpen={showPopover}
      anchorPosition={props.popoverAnchorPosition ?? 'downRight'}
      closePopover={() => setShowPopover(false)}
      panelPaddingSize='s'>
      <EuiPopoverTitle hidden={!props.currentValue}>
        <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFlexGroup justifyContent='spaceBetween'>
              <EuiFlexItem grow={false}>
                <span style={{ textTransform: 'none' }}>{props.currentValue}</span>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>{props.currentValue && props.onRefreshClick && <EuiButtonIcon id='refresh' color='primary' size='s' iconType='refresh' onClick={props.onRefreshClick} aria-label='refresh' />}</EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPopoverTitle>

      <EuiSelectable searchProps={{ placeholder: 'Find a client' }} hidden={!props.currentValue} isLoading={props.isLoading} searchable={props.options?.length > 4 ? true : undefined} options={props.options} singleSelection='always' onChange={() => {}} listProps={{ rowHeight: 40, showIcons: false }}>
        {(list, search) => (
          <>
            {search && <EuiPopoverTitle>{search}</EuiPopoverTitle>}
            {props.currentValue && !props.isLoading && list}
            {props.isLoading && <EuiLoadingSpinner size='m' />}
          </>
        )}
      </EuiSelectable>
      {props.onNewClick && (
        <EuiPopoverFooter>
          <EuiButton size='s' fullWidth onClick={onNewButtonClick}>
            {props.footerButtonText}
          </EuiButton>
        </EuiPopoverFooter>
      )}
    </EuiPopover>
  )
}
